import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Graphs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 200px;
  margin-top: 50px;
`;
